import FileExplorer from './FileExplorer';

export default FileExplorer;
